import React, { Component } from 'react';
import { Button, Input } from 'antd';

class Filter extends Component {
    state = {
        searchParams: {},
    }

    search = () => {
        const { searchParams } = this.state;
        this.props.search(searchParams);
    }

    enterSearch = e => {
        if (e.charCode === 13) {
            this.search();
        }
    }

    handleChange = (value, key) => {
        const { searchParams } = this.state;
        searchParams[key] = value;
        this.setState({ searchParams });
    }

    render() {
        const { curRole, invState } = sessionStorage;
        const { searchParams } = this.state;
        const { siteCode, siteName, userName, mobile } = searchParams;
        const isConcrete = invState == 2;
        const isConfig = invState == 3;
        const isCRC = curRole == "CRC";
        const isCTA = curRole == "CTA";
        const isPA_PM = curRole == "PA" || curRole == "PM";
        return (
            (!isConcrete || (isPA_PM || isCRC)) ?
                <div className="filter-bar">
                    {
                        !isConcrete &&
                        <div className="form-item">
                            <label className="ui-label">中心编号</label>
                            <Input
                                value={siteCode}
                                placeholder="请输入"
                                onChange={e => this.handleChange(e.target.value, 'siteCode')}
                            />
                        </div>
                    }
                    {
                        !isConcrete &&
                        <div className="form-item">
                            <label className="ui-label">中心名称</label>
                            <Input
                                value={siteName}
                                placeholder="请输入"
                                onChange={e => this.handleChange(e.target.value, 'siteName')}
                            />
                        </div>
                    }
                    {
                        !isCRC &&
                        <div className="form-item">
                            <label className="ui-label">参与临床试验人员姓名</label>
                            <Input
                                value={userName}
                                placeholder="请输入"
                                onChange={e => this.handleChange(e.target.value, 'userName')}
                            />
                        </div>
                    }
                    {
                        !isCRC &&
                        <div className="form-item">
                            <label className="ui-label">手机号</label>
                            <Input
                                value={mobile}
                                placeholder="请输入"
                                onChange={e => this.handleChange(e.target.value, 'mobile')}
                            />
                        </div>
                    }
                    <div className="form-item">
                        {
                            (isCRC || isPA_PM || (isCTA && isConfig)) &&
                            <Button type="primary" onClick={() => this.props.update({}, 'add')}>添加</Button>
                        }
                        {
                            !isCRC &&
                            <Button type="primary" onClick={this.search}>搜索</Button>
                        }
                    </div>
                </div>
            :
                null
        );
    }
}

export default Filter;


// WEBPACK FOOTER //
// ./src/components/site/piInfo/components/Filter.js